import React from "react";
import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { toStarRating } from "@b2bportal/core-utilities";
import { HotelStarRating } from "@b2bportal/lodging-api";
import type { Lodging } from "@b2bportal/lodging-api/lib/api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./Rating.module.scss";

export type RatingProps = PlatformComponentProps & {
  hotel: Lodging;
};

export const Rating = ({ hotel, className }: RatingProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.HotelCardRating,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.HotelCardRating);

  const { t } = useI18nContext();

  const { starRating } = hotel.lodging;

  if (starRating === HotelStarRating.NotAvailable) {
    return null;
  }

  return (
    <div className={clsx(block, className)}>
      <Icon className={cn("star")} iconName={IconNameEnum.starFilled} />{" "}
      {t("core-hotels.availabilityPage.results.hotelCard.rating.star", {
        count: toStarRating(starRating),
      })}
    </div>
  );
};
